import { getText, interpolate } from "shared/lib";

export interface PropertyBoundariesDisclaimerProps {
  contactCouncilUrl: string;
  isRemoving?: boolean;
}

export function PropertyBoundariesDisclaimer({
  contactCouncilUrl,
  isRemoving,
}: PropertyBoundariesDisclaimerProps) {
  return (
    <div className="text-textPrimary border-interactiveBorder rounded-xs bg-interfaceBgDarkPaper flex flex-col gap-1 border-l-4 p-3 pl-4">
      <h3 className="text-headingsm">
        {getText("🌳 Only enter trees within the property’s boundaries")}
      </h3>

      <p className="text-bodysm leading-4.5">
        {isRemoving
          ? interpolate(
              "If you’re proposing to remove or prune a tree on a neighbouring property, make a separate enquiry using the that property’s address. This way, we can properly assess the tree removal or pruning against its relevant site-specific planning rules. If the tree is somewhere like a nature strip or road reserve, {{contactCouncilLink}}.",
              {
                contactCouncilLink: (
                  <a
                    className="text-textLink hover:text-textLinkHover cursor-pointer underline"
                    href={contactCouncilUrl}
                    rel="noopener noreferrer"
                    tabIndex={0}
                    target="_blank"
                  >
                    contact Council
                  </a>
                ),
              },
            )
          : interpolate(
              "If you’re proposing to remove or prune a tree that’s outside the property’s boundaries, either {{contactCouncilLink}}, or make a separate enquiry using the property’s address where the tree is located. This way, we can properly assess the tree removal or pruning against its relevant site-specific planning rules.",
              {
                contactCouncilLink: (
                  <a
                    className="text-textLink hover:text-textLinkHover cursor-pointer underline"
                    href={contactCouncilUrl}
                    rel="noopener noreferrer"
                    tabIndex={0}
                    target="_blank"
                  >
                    contact Council
                  </a>
                ),
              },
            )}
      </p>
    </div>
  );
}
